export enum CodigoIndeferimentoCancelamentoNotaEnum {

  INDEFERIDO = "1 - Cancelamento de NFS-e Indeferido",
  INDEFERIDOSEMMERITO = "2 - Cancelamento de NFS-e Indeferido Sem Análise de Mérito"

}
